import authActions from "./auth";
import eventActions from "./events";
import shiftActions from "./shifts";
import talentActions from "./talents";
import tierActions from "./tiers";

const actionTypes = {
  talents: talentActions,
  auth: authActions,
  events: eventActions,
  shifts: shiftActions,
  tiers: tierActions
}

export default actionTypes;
